/** Master-club post status IDs from the backend. */
export const POST_STATUS_ID = {
  DRAFT: 1,
  PUBLISHED: 2,
  REJECTED: 3,
  PROCESSING: 4,
};

/** UI labels keyed by status ID (null = no label shown). */
export const POST_STATUS_LABEL = {
  [POST_STATUS_ID.DRAFT]: "(Bozza)",
  [POST_STATUS_ID.PUBLISHED]: null,
  [POST_STATUS_ID.REJECTED]: "(Rifiutato)",
  [POST_STATUS_ID.PROCESSING]: "(In elaborazione)",
};

const normalizeStatusId = (postGroup) => {
  const raw =
    postGroup?.status?.id ??
    postGroup?.status_id ??
    postGroup?.post?.status_id ??
    postGroup?.post?.status?.id;

  if (raw === null || raw === undefined || raw === "") return null;
  const id = Number(raw);
  return Number.isFinite(id) ? id : null;
};

const getStatusName = (postGroup) =>
  String(
    postGroup?.status?.name ??
      postGroup?.status_name ??
      postGroup?.post?.status?.name ??
      "",
  ).trim();

const hasStatusId = (postGroup, statusId) =>
  normalizeStatusId(postGroup) === statusId;

export const isPostPublished = (postGroup) =>
  hasStatusId(postGroup, POST_STATUS_ID.PUBLISHED) ||
  getStatusName(postGroup) === "Pubblicato";

export const isPostRejected = (postGroup) =>
  hasStatusId(postGroup, POST_STATUS_ID.REJECTED) ||
  getStatusName(postGroup) === "Rifiutato";

/** Video transcoding in progress — webhook will flip to published. */
export const isPostProcessing = (postGroup) =>
  hasStatusId(postGroup, POST_STATUS_ID.PROCESSING) ||
  getStatusName(postGroup) === "In elaborazione";

export const isPostDraft = (postGroup) =>
  hasStatusId(postGroup, POST_STATUS_ID.DRAFT) ||
  getStatusName(postGroup) === "Bozza";

/** Label shown under the author name for non-published posts. */
export const getPostStatusLabel = (postGroup) => {
  if (!postGroup || isPostPublished(postGroup)) return null;

  const id = normalizeStatusId(postGroup);
  if (id != null && Object.prototype.hasOwnProperty.call(POST_STATUS_LABEL, id)) {
    return POST_STATUS_LABEL[id];
  }

  if (isPostProcessing(postGroup)) return POST_STATUS_LABEL[POST_STATUS_ID.PROCESSING];
  if (isPostRejected(postGroup)) return POST_STATUS_LABEL[POST_STATUS_ID.REJECTED];
  if (isPostDraft(postGroup)) return POST_STATUS_LABEL[POST_STATUS_ID.DRAFT];

  return "(In attesa di approvazione)";
};

/** Whether badge moderators can manually publish/reject this post. */
export const canModeratePost = (postGroup) =>
  !!postGroup && !isPostPublished(postGroup) && !isPostRejected(postGroup);
